const colors = {
  mainColor: '#82B75E',
  mainColorDarker: '#558C2F',
  mainColorLighter: '#BADBA4',

  mainColorContrast: '#45547F',
  mainColorContrastDarker: '#2A334D',
  mainColorContrastLighter: '#B2C6FF',

  statusColorError: '#CF3200',
  statusColorWarning: '#F3AF00',
  statusColorSuccess: '#2BD971',

  textColorPrimary: '#3C3C3B',
  textColorSecondary: '#787878',
  textColorTertiary: '#B7B7B7',
  textColorDisabled: '#E2E2E2',

  gray300: '#B7B7B7',
  gray400: '#E2E2E2',

  backgroundColorWhite: '#FFFFFF',
  backgroundColorLight: '#F5F5F5',
  backgroundColorDark: 'rgba(0, 0, 0, 0.9)',
  mainColorBackground: '#EDFAE4',
  contrastColorBackground: '#E8EDF2',

  tooltipBackground: 'rgba(60, 60, 59, 0.8)',
};

export default colors;
